module.exports = __webpack_public_path__ + "img/icon_graph_w.ab2a0e7a.svg";